// extracted by mini-css-extract-plugin
export default {"root":"trial-notification_root__xnGG0","text":"trial-notification_text__1g065","link":"trial-notification_link__UYMLu","icon":"trial-notification_icon__7JpTR"};